/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

$(document).ready(function() {
  
  // SUBSCRIBE POPUP
  /*$(function() {
    if (Cookies.get('alreadySeen') == null) {
      setTimeout(function() {
        $('#subscribe-popup').fadeIn();
        $('#subscribe-open').fadeOut();
        Cookies.set('alreadySeen', true, {expires: 1});
      }, 5000);
    }
  });*/
  $('#subscribe-popup #close').click(function() {
    $('#subscribe-popup').hide();
    $('#subscribe-open').show();
  });
  $('#subscribe-open .btn').click(function() {
    $('#subscribe-popup').show();
    $('#subscribe-open').hide();
  });
  $('#mc-embedded-subscribe').attr('disabled', true);
  $('#mce-EMAIL').keyup(function() {
      if($(this).val().length != 0) {
        $('#mc-embedded-subscribe').attr('disabled', false);
      } else {
        $('#mc-embedded-subscribe').attr('disabled', true);
      }
  });

  // HOMEPAGE
  if ($('.template-index').length > 0) {
    $('.slideshow__slide--93a91b70-bfce-4491-a54e-c1c0b4011826 .slideshow__heading').after('<h5 class="slideshow__subheading">A supremely durable line of enrichment that stands in a class all its own. Meet KONG® Equine.</h5>');
    $('#retailer-list').slick({
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 5,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }
  
  // PRODUCT PAGE
  if ($('.template-product').length > 0) {
    // Product image slider
    $('.product-gallery').slick({
      dots: true
    });
    // Tabs section
    $('.tabs a').click(function() {
      $('.tabs a').removeClass('active');
      $('.tabs-content > div').removeClass('active');
      $(this).addClass('active');
      $('#' + $(this).attr('data-filter')).addClass('active');
    });
    // Product features image
    if ($('#product-features-image').length > 0) {
      $('#product-features-image').appendTo('#product-features');
    }
    // Open recommended products in new tab
    setTimeout(function() {
      if ($('#shopify-section-product-recommendations').length > 0) {
        $('.product-recommendations a').attr('target','_blank');
      }
    }, 2000);
  }
  
  // CART PAGE
  if ($('.template-cart').length > 0) {
    $('[name="checkout"]').click(function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the Terms & Conditions before you can proceed.");
        return false;
      }
    });
  }
  
  // FAQ PAGE
  $('.toggle-question').click(function() {
    $(this).children('.toggle-arrow').toggleClass('rotated').parent().next('.toggle-answer').slideToggle();
    $(this).siblings('.toggle-question').children('.toggle-arrow').removeClass('rotated').parent().next('.toggle-answer').slideUp();
    return false;
  });
  
  // RETAIL PAGES
  if ($('#retail-store').length > 0) {
    $('#view-stores').click(function() {
      $('#retail-store-list').toggle();
      $('body, html').animate({
        scrollTop: $('#retail-store-list').offset().top - 58
      });
    });
  }

});